import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';

@MergeSchema({
    entity: ActivityEntityName.BulkInvoiceJob,
    name: 'BulkInvoiceJobSchema',
})
export class BulkInvoiceJobMergeData {

    @MergeField()
    jobNumber: string;

    @MergeField({
        displayName: "Customer WO"
    })
    customerWO: string;

    @MergeField()
    type: string;

    @MergeField()
    description: string;

    @MergeField()
    addressName: string;

    @MergeField()
    contractors: string;

    @MergeField()
    resources: string;

    @MergeField()
    appointments: string;
}

export const BulkInvoiceJobMergeSchema = getSchema(BulkInvoiceJobMergeData);